
<template>
  <div>
    <PageHeader />
    <b-overlay :show="assistant.isFetchingAssistant">
      <b-card class="mb-4">
        <AssistantForm :assistant-detail="assistantDetail" />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  page: {
    title: 'ข้อมูลผู้ช่วย',
  },
  components: {
    AssistantForm: () => import('@components/forms/assistant-form'),
  },
  data() {
    return {
      assistantDetail: undefined
    }
  },
  computed: {
    ...mapState(['assistant']),
    assistantId() {
      return this.$route.params.id === 'create' ? null : this.$route.params.id
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions(['fetchPermissions', 'fetchAssistant']),
    async fetchData() {
      await this.fetchPermissions()
      if (this.assistantId) {
        this.assistantDetail = await this.fetchAssistant(this.assistantId)
      }
    },
  },
}
</script>
